import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box, Flex, Text } from 'rebass/styled-components'
import { useCustomerRecover } from '../../graphql/mutations'
import { IonPage, IonItem, IonLabel, IonInput, IonButton } from '@ionic/react'
import Header from '../../components/Header'
import IonContent from '../../components/IonContent'

export default () => {
    const [email, setEmail] = useState('')
    const [mutate] = useCustomerRecover()
    const handleRecover = () => {
        mutate({
            variables: {
                email,
            },
        })
    }

    return (
        <IonPage>
            <Header title="Reset"></Header>
            <IonContent fullscreen>
                <IonItem>
                    <IonLabel>Email</IonLabel>
                    <IonInput
                        value={email}
                        onIonChange={(e) => setEmail(e.target.value)}
                    ></IonInput>
                </IonItem>

                <Box my="20px" px="20px">
                    <IonButton color="primary" expand="block" onClick={handleRecover}>
                        Send
                    </IonButton>
                    <Flex justifyContent="space-between" mt="10px">
                        <Link to="/login">
                            <Text>Login</Text>
                        </Link>
                        <Link to="/register">
                            <Text>Register</Text>
                        </Link>
                    </Flex>
                </Box>
            </IonContent>
        </IonPage>
    )
}
